import { Link } from "react-router-dom";
import { ThreeDots as Loader } from "react-loader-spinner";
import { useOrder } from "../../hooks/queries/useOrder";
import { useTotals } from "../../hooks/useTotals";
import colors from "../../styles/colors";

import {
  Container,
  OrderContainer,
  IconProductType,
  LiquidContainer,
  GrossContainer,
} from "./styles";

const Footer = () => {
  // Busca dados do pedido via React Query
  const { data: orderData, isLoading } = useOrder();

  const items = orderData?.items || [];
  const nrOrder = orderData?.nr_pedido ? String(orderData.nr_pedido) : "";

  // Calcula totais usando hook centralizado
  const { vlrMinimo = 50 } = orderData?.clientInfo?.session?.cliente || {};
  const totals = useTotals(items, vlrMinimo);

  return (
    <Container>
      <OrderContainer>
        <div>
          <Link to="/pedido">
            <strong>Seu pedido:</strong>
            <span>{nrOrder !== "" ? `#${nrOrder}` : ""}</span>
          </Link>
          {isLoading && (
            <Loader color="rgba(0, 0, 0, 0.5)" height={15} width={30} />
          )}
        </div>
      </OrderContainer>
      <IconProductType color={colors.legend.red}>
        <p>
          <strong>Perfumaria:</strong>
          <span>{totals.perfumaria}</span>
        </p>
      </IconProductType>
      <IconProductType color={colors.bloqueio}>
        <p>
          <strong>Kit:</strong>
          <span>{totals.kit}</span>
        </p>
      </IconProductType>
      <IconProductType color={colors.legend.green}>
        <p>
          <strong>Medicamentos:</strong>
          <span>{totals.medicamentos}</span>
        </p>
      </IconProductType>
      <LiquidContainer>
        <p>
          <strong>Líquido:</strong>
          <span className={!totals.minimumReached ? "minimumNotReached" : ""}>
            {totals.liquid}
          </span>
        </p>
      </LiquidContainer>
      <GrossContainer>
        <p>
          <strong>Total:</strong>
          <span>{totals.total}</span>
        </p>
      </GrossContainer>
    </Container>
  );
};

export default Footer;
